import { createI18n } from 'vue-i18n'
import { setLocale } from '@vee-validate/i18n';

function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

const host = document.location.hostname?.toLocaleLowerCase() ?? null;

let defaultLocale = 'en';

if (host !== null) {
    if (host.endsWith('.pl')) {
        defaultLocale = 'pl';
    } else if (host.endsWith('.lt')) {
        defaultLocale = 'lt';
    }
}

const locale = localStorage.getItem('lang') || defaultLocale;

setLocale(defaultLocale);

export default createI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
})
